import axiosInstance from "./axios/axios_instance"
const http = axiosInstance("/protected",  null, "/logout")

const getAllResponses = (type) => http.get(`/all_responses/${type}`)

export default {
    getAllResponses,
}